import { topics } from "@/mocks/home";

export default function TopicGrid() {
  return (
    <section id="topics" className="w-full px-4 md:px-10 py-14 md:py-20 bg-background-100/60 border-y hairline">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8 md:mb-10">
        <div>
          <span className="text-xs md:text-sm tracking-[0.3em] text-secondary-700 uppercase">
            Topics
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            专题索引
          </h2>
          <p className="mt-3 max-w-2xl text-sm md:text-base text-foreground-600 leading-relaxed">
            按话题聚合今日更新，同一事件的后续都收在同一个专题里，
            追某个方向的料从这里进最快。
          </p>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5">
        {topics.map((topic) => (
          <a
            key={topic.name}
            href="#feed"
            className="group flex items-center gap-3 md:gap-4 rounded-lg border hairline bg-background-50 px-4 md:px-5 py-4 hover:border-secondary-400 transition-colors cursor-pointer"
          >
            <span className="w-10 h-10 md:w-11 md:h-11 rounded-md bg-secondary-100 text-secondary-800 flex items-center justify-center shrink-0 group-hover:bg-secondary-500 group-hover:text-background-50 transition-colors">
              <i className={`${topic.icon} text-lg md:text-xl`} />
            </span>
            <span className="min-w-0">
              <span className="block font-heading text-sm md:text-base font-bold text-foreground-950 truncate">
                {topic.name}
              </span>
              <span className="block text-xs text-foreground-500 mt-0.5">
                {topic.count} 条
              </span>
            </span>
          </a>
        ))}
      </div>
    </section>
  );
}